module.exports = __webpack_public_path__ + "cdd97ec5c86a87b57556d545b70073f2.png";